
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-arrivals",
      function () {
        return require("private-next-pages/new-arrivals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-arrivals"])
      });
    }
  